"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var main_1 = require("@r1-frontend/ui-react/components/svg/main");
var ST = __importStar(require("./styled"));
var CityIcon = function (_a) {
    var cityIndex = _a.cityIndex;
    switch (cityIndex) {
        case 0:
            return <main_1.Moscow size={24}/>;
        case 1:
            return <main_1.StPetersburg size={24}/>;
        default:
            return <></>;
    }
};
var TopCities = function (_a) {
    var topCities = _a.topCities, onCitySelect = _a.onCitySelect;
    return (<ST.TopCitiesWrap>
            {topCities.map(function (topCity, index) { return (<ST.TopCityElement key={topCity.provider_id} onClick={function () { return onCitySelect(topCity); }} data-test='top-city'>
                    <CityIcon cityIndex={index}/>
                    {topCity.name}
                </ST.TopCityElement>); })}
        </ST.TopCitiesWrap>);
};
exports.default = TopCities;
